export default {
    table: {
        'selectBtn': true,
        'clickModify': true,
        'leftWidth': 90,
        'height': '240px',
        'leftOperation': true,
        'columns': [
            {
                label: '车型',
                prop: 'equipmentName',
                width: 100,
                type: 'input',
                options: []
            },
            {
                label: '装载车辆下限',
                prop: 'minVolume',
                width: 110,
                type: 'input'
            },
            {
                label: '装载车辆上限',
                prop: 'maxVolume',
                width: 110,
                type: 'input'
            },
            {
                label: '限行区域是否可通行',
                prop: 'enableRestrictArea',
                width: 120,
                type: 'select',
                options: [
                    { label: '是', value: '1' },
                    { label: '否', value: '0' }
                ]
            },
            {
                label: '排车数量',
                prop: 'equipmentNum',
                width: 110,
                type: 'inputInteger',
                mustFill: true,
                require: true
            }
        ],
        action: [
            {
                type: 'text',
                label: '编辑',
                size: 'small',
                event: 'edit'
            }
        ]
    },
    rules: {
        siteName: [
            { required: true, message: '请选择服务平台', trigger: 'change' }
        ],
        coverSiteNameListString: [
            { required: true, message: '请选择服务平台', trigger: 'change' }
        ],
        inDistanceValue: [
            { required: true, message: '请输入串点集中度', trigger: 'change' }
        ],
        accValue: [
            { required: true, message: '请输入加速参数', trigger: 'change' }
        ],
        slackNValue: [
            { required: true, message: '请输入模板编码', trigger: 'change' }
        ],
        slackDValue: [
            { required: true, message: '请输入线路距离上限', trigger: 'change' },
            { type: 'number', message: '必须为数字值' }
        ],
        aveSpeedValue: [
            { required: true, message: '请输入车辆的平均时速', trigger: 'change' },
            { type: 'number', message: '必须为数字值' }
        ],
        maxRouteTimeValue: [
            { required: true, message: '请输入线路最长用时', trigger: 'change' }
        ],
        algorithmStatus: [
            { required: true, message: '请选择是否启用', trigger: 'change' }
        ],
        efValue: [
            { required: true, message: '请输入每小时装卸点数', trigger: 'change' }
        ]
    },
    siteParams: {
        name: '服务平台',
        value: 'siteName',
        unfold: true,
        span: 4,
        type: 'advance',
        advanceConfig: [
            { prop: 'escoCompanyNameCn', value: '平台名称' },
            { prop: 'escoCompanyNo', value: '平台编码' }
        ],
        tableConfig: [
            { prop: 'escoCompanyNameCn', value: '平台名称' },
            { prop: 'escoCompanyNo', value: '平台编码' }
        ],
        advanceUrl: '/searchPlatform',
        cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
    },
    coverSiteParam: {
        name: '覆盖服务平台',
        value: 'coverSiteNameListString',
        type: 'advance',
        multiple: true,
        border: true,
        dialogWidth: '800px',
        multipleTableColumn: {
            prop: 'escoCompanyNameCn', value: '平台名称'
        },
        advanceConfig: [
            { prop: 'escoCompanyNameCn', value: '平台名称' },
            { prop: 'escoCompanyNo', value: '平台编码' }
        ],
        tableConfig: [
            { prop: 'escoCompanyNameCn', value: '平台名称' },
            { prop: 'escoCompanyNo', value: '平台编码' }
        ],
        advanceUrl: '/searchPlatform',
        cbParams: ['escoCompanyNo#coverSiteCodeListString', 'escoCompanyNameCn#coverSiteNameListString']
    }
};
